// Eine hcap-Methode als Promise - der gemeinsame Weg fuer alle LG-Aufrufe.
//
// hcap arbeitet mit onSuccess/onFailure in einem Parameter-Objekt. Der Wrapper
// macht daraus ein Promise und bringt zwei Dinge mit, ohne die es auf echten
// Geraeten nicht geht:
//
//  - Ein Zeitbudget. Manche Firmwares rufen bei unbekannten Methoden oder in
//    der Ausschaltsequenz ueberhaupt keinen Callback mehr auf; ohne Timeout
//    haengt der Aufrufer dann fuer immer. Auf einem UM767H hat genau das die
//    Einstellungs-Abfrage von 100 ms auf 8 s gebracht.
//  - Eine klare Absage, wenn es die Methode gar nicht gibt: dieselbe hcap-
//    Version bringt je nach Modell unterschiedliche Namensraeume mit.
//
// Bewusst eigenstaendig und ohne Abhaengigkeit auf Cast oder Settings: beide
// benutzen ihn, und ein dritter Nachbau war schon einer zu viel.

const DEFAULT_TIMEOUT_MS = 2000;

export function hasHcap() {
  try {
    return typeof hcap !== 'undefined' && !!hcap;
  } catch (e) {
    return false;
  }
}

export function hcapNamespace(name) {
  if (!hasHcap()) return undefined;
  try {
    return hcap[name];
  } catch (e) {
    return undefined;
  }
}

export function hasHcapMethod(namespace, method) {
  const api = hcapNamespace(namespace);
  try {
    return !!api && typeof api[method] === 'function';
  } catch (e) {
    return false;
  }
}

export function hcapCall(namespace, method, params, timeoutMs) {
  return new Promise((resolve, reject) => {
    const api = hcapNamespace(namespace);
    if (!hasHcapMethod(namespace, method)) {
      reject(new Error('hcap.' + namespace + '.' + method + ' fehlt'));
      return;
    }
    let settled = false;
    const timer = setTimeout(() => {
      if (settled) return;
      settled = true;
      reject(new Error('hcap.' + namespace + '.' + method + ' Zeitueberschreitung'));
    }, timeoutMs || DEFAULT_TIMEOUT_MS);
    const finish = (fn, arg) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      fn(arg);
    };
    try {
      api[method](
        Object.assign({}, params, {
          onSuccess: function(s) {
            finish(resolve, s);
          },
          onFailure: function(f) {
            finish(reject, f);
          },
        })
      );
    } catch (e) {
      finish(reject, e);
    }
  });
}



// WEBPACK FOOTER //
// ./src/helpers/LgHcap.js